module.exports = __webpack_public_path__ + "img/m4x8luomuzhu.prt.2e67f11d.jpg";